import {roundedMilesBetweenCoordinates} from "../../../../utils/distance";
import {useUserCoordinates} from "../../../../hooks/useGeolocateUser";
import {QueryState, QueryStatus} from "../../../../hooks/useQueryController";
import {LocationAddress} from "@components/Booking/LocationSelection/types";

type Locatable = {locationAddress?: LocationAddress | null};
export type WithDistance<T> = T & {distance?: number};

/**
 * Given some locations, return those locations with an extra "distance" field, determining
 * how far away that location is from the user in miles.
 */
export const useWithDistanceFromUser = <T extends Locatable>(
  locations: T[],
): QueryState<WithDistance<T>[] | undefined> => {
  const query = useUserCoordinates();
  const {data, ...otherQueryParams} = query;

  if (otherQueryParams.status === QueryStatus.SUCCESS) {
    return {
      ...otherQueryParams,
      data: locations?.map(location => {
        const latitude = location?.locationAddress?.latitude;
        const longitude = location?.locationAddress?.longitude;
        if (!latitude || !longitude) return location;
        return {
          ...location,
          distance: roundedMilesBetweenCoordinates(latitude, longitude, data.x, data.y),
        };
      }),
    };
  }

  return {
    ...otherQueryParams,
    data: locations,
  };
};
